import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

/**
 * Google Analytics 4 tracking component
 * Tracks page views on route changes
 */
export const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track if GA ID is configured
    if (!GA_MEASUREMENT_ID || !window.gtag) return;

    // Track page view
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

/**
 * Track custom events
 * @param {string} eventName - Event name
 * @param {Object} params - Event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  
  window.gtag('event', eventName, params);
};

/**
 * Track button clicks
 * @param {string} buttonName - Button identifier
 * @param {string} category - Event category
 */
export const trackButtonClick = (buttonName, category = 'engagement') => {
  trackEvent('click', {
    event_category: category,
    event_label: buttonName,
  });
};

/**
 * Track form submissions
 * @param {string} formName - Form identifier
 */
export const trackFormSubmit = (formName) => {
  trackEvent('form_submit', {
    event_category: 'conversion',
    event_label: formName,
  });
};

/**
 * Track contact conversions
 * @param {string} method - Contact method (form, whatsapp, email, phone)
 */
export const trackContact = (method) => {
  trackEvent('contact', {
    event_category: 'conversion',
    event_label: method,
    value: 1,
  });
};

export default GoogleAnalytics;
